/** Maps sidebar item id → required permissions. Empty array = always visible. */
export const permissionMap: Record<string, string[]> = {
    dashboard: [],
    students: ['manage_students'],
    staff: ['manage_staff'],
    schools: ['manage_school_settings'],
    classes: ['manage_classes_and_subjects'],
    subjects: ['manage_classes_and_subjects'],
    schoolSubjects: ['manage_classes_and_subjects'],
    allocations: ['manage_classes_and_subjects'],
    timetable: ['manage_classes_and_subjects'],
    attendance: ['manage_attendance'],
    gatePass: ['manage_attendance'],
    exams: ['manage_grades_and_exams'],
    marks: ['manage_grades_and_exams'],
    results: ['manage_grades_and_exams'],
    homework: ['manage_assignments'],
    noticeboard: ['manage_notices'],
    holidays: ['manage_school_settings'],
    sessions: ['manage_school_settings'],
    feeStructures: ['manage_fees_and_invoices'],
    studentDiscounts: ['manage_fees_and_invoices'],
    invoices: ['manage_fees_and_invoices'],
    collection: ['manage_fees_and_invoices'],
    transactions: ['manage_fees_and_invoices'],
    feeDefaulters: ['manage_fees_and_invoices'],
    expenses: ['record_expenses'],
    expenseCategories: ['manage_expenses'],
    reports: ['manage_fees_and_invoices'],
    fleet: ['manage_organization'],
    routeBuilder: ['manage_organization'],
    passengerAlloc: ['manage_organization'],
    organization: ['manage_organization'],
    departments: ['manage_organization'],
    designations: ['manage_organization'],
    tasks: [],
};
